import axios from "../../../../api/axios";
import { User } from "../../../../types/types";

type ChatMember = {
  user_id: number;
  role: string;
  joined_at: string;
  last_read_msg_id: string | null;
  user: User;
};

export interface GetOrCreateRoomResponse {
  data: {
    chatId: number;
    created: boolean;
    members: ChatMember[];
  };
}

export interface GetOrCreateRoomRequest {
  otherUserId: number;
}

export interface AddMessageRequest {
  room: number;
  type: string;
  text: string;
  meta?: string;
  isGino: boolean;
}

export interface AddMessageResponse {
  data: {
    id: number;
    chat_id: number;
    sender_id: number;
    type: string;
    text: string;
    meta: string | null;
    created_at: string;
    edited_at: string | null;
    deleted_at: string | null;
  };
}

export const getOrCreateDirectRoom = async (
  params: GetOrCreateRoomRequest
): Promise<GetOrCreateRoomResponse["data"]> => {
  const response = await axios.post<GetOrCreateRoomResponse>("/chat-ws/direct/get-or-create", params);
  return response.data.data;
};

export interface ChatMessage {
  id: number;
  chat_id: number;
  sender_id: number;
  type: string;
  text: string;
  meta: string | null;
  created_at: string;
  edited_at: string | null;
  deleted_at: string | null;
}

export const sendMessage = async (chatId: number, params: AddMessageRequest): Promise<AddMessageResponse["data"]> => {
  const response = await axios.post<AddMessageResponse>(`/chat-ws/chats/${chatId}/messages`, params);
  return response.data.data;
};

export type ChatRoom = {
  chatId: number;
  type: string;
  title: null;
  created_at: string;
  updated_at: string;
  last_message?: ChatMessage;
  members: User[];
};
export const getMessages = async (chatId: number): Promise<ChatMessage[]> => {
  const { data } = await axios.get<{ data: ChatMessage[] }>(`/chat-ws/chats/${chatId}/messages`);
  return data.data.reverse();
};

export const getChatList = async (): Promise<ChatRoom[]> => {
  const response = await axios.get<{ data: ChatRoom[] }>("/chat-ws/my/chats?isGino=true");
  return response.data.data;
};
